module.exports = __webpack_public_path__ + "static/Vinay-ab65956b36ed2d80fd5bfd81f24b9a3f.jpg";